<div class="dialog">
  @if (isMobileView()) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="close()" [ngStyle]="{ cursor: 'pointer' }" translate>Cancel</p>
      <h3 class="mobile-app-bar__heading">{{ 'News' | translate }} {{ (currentNews?.id ? 'Edit' : 'Add') | translate | lowercase }}</h3>
      <!--    <p [ngStyle]="{ cursor: 'pointer' }" class="disabled" disabled="true" translate>Save</p>-->
    </header>
  }

  @if (!isMobileView()) {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'News' | translate }} {{ (currentNews?.id ? 'Edit' : 'Add') | translate | lowercase }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px', cursor: 'pointer' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    <form [formGroup]="form" action="" class="form">
      <div class="align-fields">
        <div>
          <!-- Image Selector -->
          <div class="input-group">
            <label for="image" translate>Image</label>
            <app-image-selector
              (imageSelected)="selectedImage = $event"
              [aspectRatio]="4 / 3"
              [entityId]="currentNews?.id"
              [fullWidthPreview]="true"
              [imageCropper]="true"
              [isUpdateMode]="isUpdateMode"
              [sectionType]="SectionType.NEWS"
              formControlName="image"
              id="image"
              name="image"
            ></app-image-selector>
            <!--            <app-form-error [control]="form.get('image')" [name]="'Image' | translate"></app-form-error>-->
          </div>

          <!-- News Title -->
          <div class="input-group --required">
            <label for="title" translate>Add a Title</label>
            <input [placeholder]="'Add a Title' | translate" class="full-width-input" formControlName="title" id="title" name="title" type="text" />
            <app-form-error [control]="form.get('title')" [name]="'Title' | translate"></app-form-error>
          </div>

          <!-- Description -->
          <div class="input-group --required">
            <label for="headline" translate>Content</label>
            <textarea [placeholder]="'Enter content' | translate" class="full-width-input" formControlName="headline" id="headline" name="headline" rows="3"></textarea>
            <app-form-error [control]="form.get('headline')" [name]="'Content' | translate"></app-form-error>
          </div>
          <!--  Type  -->
          <div class="input-group --required">
            <label for="newsTypes" translate>Type</label>
            <app-dropdown
              [options]="newsTypes"
              bindValue="value"
              displayName="key"
              formControlName="audience"
              id="newsTypes"
              name="newsTypes"
              [class.disabled]="shouldLockGroupDropdown"
            ></app-dropdown>
            <app-form-error [control]="form.get('audience')" [name]="'Task Type' | translate"></app-form-error>
          </div>
          <!--  Dynamic dropdown rendering For Groups  -->
          @if (form.get('audience').value === NewsType.Group) {
            <div class="input-group --required">
              <label for="groupId" translate>Group</label>
              <!-- TODO: Commented out as multi select is currently not required /-->
              <!--            <ng-select-->
              <!--              [addTagText]="'Add Group' | translate"-->
              <!--              [closeOnSelect]="true"-->
              <!--              [items]="groups"-->
              <!--              [maxlength]="1"-->
              <!--              [multiple]="false"-->
              <!--              [placeholder]="'Select Group' | translate"-->
              <!--              [searchable]="true"-->
              <!--              addTag="true"-->
              <!--              bindLabel="name"-->
              <!--              bindValue="id"-->
              <!--              class="custom"-->
              <!--              formControlName="groups"-->
              <!--              id="groupId"-->
              <!--              name="groupId"-->
              <!--            ></ng-select>-->
              <app-dropdown
                [options]="groups"
                [placeholder]="'Group' | translate"
                bindValue="id"
                displayName="name"
                formControlName="groups"
                id="groupId"
                name="groupId"
                [class.disabled]="shouldLockGroupDropdown"
              ></app-dropdown>
              <app-form-error [control]="form.get('groupId')" [name]="'Group' | translate"></app-form-error>
            </div>
          }
          <!-- Tags -->
          <div class="input-group">
            <label for="newsTags" translate>Add Tags</label>
            <ng-select
              [addTagText]="'Add Tag' | translate"
              [addTag]="addTagFn"
              [closeOnSelect]="true"
              [items]="tags || []"
              [multiple]="true"
              [notFoundText]="'No tags available' | translate"
              [placeholder]="'Select Tags' | translate"
              [searchable]="true"
              bindLabel="label"
              bindValue="value"
              class="custom"
              formControlName="newsTags"
              id="newsTags"
              name="newsTags"
            ></ng-select>
          </div>

          <!--  Show Guests  -->
          <div class="input-group flex-row-start-center gap-14">
            <input class="toggle-btn" formControlName="showGuestList" id="showGuests" name="showGuests" type="checkbox" />
            <label class="reset-margin-bottom" for="showGuests" translate>Show Guests</label>
          </div>
          <!-- IsHighlighted -->
          <div class="input-group flex-row-start-center gap-14">
            <input class="toggle-btn" formControlName="isHighlighted" id="isHighlighted" name="isHighlighted" type="checkbox" />
            <label class="reset-margin-bottom" for="isHighlighted" translate>News Highlight</label>
          </div>
        </div>
      </div>
    </form>
  </div>

  <footer>
    <div class="dialog__footer">
      @if (!isMobileView()) {
        <div class="dialog__footer__buttons">
          <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="(currentNews ? 'Update' : 'Save') | translate"></app-button>
        </div>
      }
    </div>
    @if (isMobileView()) {
      <div class="mobile-button mb-34 mx-16">
        <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="(currentNews ? 'Update' : 'Save') | translate" cssClass="button-primary button-full"></app-button>
      </div>
    }
  </footer>
</div>
